import { AgentChatMessage } from '../agent-orchestrator/agent-orchestrator.service';
import { normalizeRetrievalMode } from '../../../../shared/utils/retrieval-mode.util';
import {
  EngagingLoaderStep,
  THINKING_STEP_ACTION
} from '../../../../shared/components/engaging-loader/engaging-loader.component';

function normalizeFilePathList(value: unknown): string[] {
  if (!Array.isArray(value)) {
    return [];
  }
  return value
    .map((path) => (typeof path === 'string' ? path.trim() : ''))
    .filter((path) => path.length > 0);
}

export function extractFilePathsFromHistoryAnswer(answer: unknown): string[] {
  if (!answer || typeof answer !== 'object' || Array.isArray(answer)) {
    return [];
  }

  const answerObj = answer as {
    file_path?: unknown;
    metadata?: { file_path?: unknown };
  };

  const directPaths = normalizeFilePathList(answerObj.file_path);
  if (directPaths.length > 0) {
    return directPaths;
  }

  return normalizeFilePathList(answerObj.metadata?.file_path);
}

/**
 * Rebuilds the thinking step from a persisted `answer.thinking` value (regulations only,
 * the sole agent that saves it) so the collapsed timeline survives a thread load.
 */
function buildThinkingSteps(answer: unknown): EngagingLoaderStep[] | undefined {
  const thinking = (answer as { thinking?: unknown })?.thinking;
  const reasoning = typeof thinking === 'string' ? thinking.trim() : '';
  if (!reasoning) {
    return undefined;
  }
  return [{ action: THINKING_STEP_ACTION, reasoning, is_complete: true, type: 'analyzing' }];
}

export function mapHistoryResponseToAgentMessage(
  resp: any,
  imageVisualization?: string
): AgentChatMessage {
  const fromAnswer = extractFilePathsFromHistoryAnswer(resp.answer);
  const file_paths =
    fromAnswer.length > 0 ? fromAnswer : extractFilePathsFromHistoryAnswer(resp);
  return {
    question: resp.question,
    answer: resp.answer?.text ?? '',
    image_visualization: imageVisualization ?? resp.image_visualization ?? '',
    updated_at: resp.updated_at,
    pills: resp.source_metadata?.follow_up_questions || [],
    metadata: resp.source_metadata?.references || resp.metadata,
    response_id: resp.response_id || '',
    is_like: resp.is_like,
    feedback: resp.feedback,
    comments: resp.comments ?? resp.comment,
    file_paths: file_paths.length > 0 ? file_paths : undefined,
    retrieval_mode: normalizeRetrievalMode(resp.answer?.retrieval_mode),
    completedReasoningSteps: buildThinkingSteps(resp.answer),
  };
}
